<template>
    <transition-group tag="div" class="loading_container" name="loading_page">
        <div class="loading_process_wrap" v-show="loadingProcess" key="loading_process">
            <img  src="../assets/images/logo_loading.png" class="logo_loading" alt="">
            <div class="loading-progress">
                <div class="loading-progress__bar" :style="{ width: process + '%', transition:  `width ${transDuration}s` }"></div>
            </div>
        </div>
        <video ref="loadingvideo" v-show="!loadingProcess" key="loading_video" preload="auto" muted :src="loadingUrl" class="logo_anime"></video>
    </transition-group>
</template>

<script>
export default {
    name: "loading",
    props: ["process", "transDuration", "loadingProcess"],
    components: {

    },
    data: () => ({
    }),
    created() {
    },
    mounted() {

    },
    watch: {
        loadingProcess(val) {
            if(!val) {
                let playPromise = this.$refs['loadingvideo'].play();
                if (playPromise !== undefined) {
                    playPromise.then(_ => {
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            }
        }
    },
    computed: {
        loadingUrl() {
            return this.$store.state.VIDEO_ARR.loading;
        }
    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.loading_container {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000;
    overflow: hidden;

    .loading_process_wrap {
        width:  100%;
        height: 100%;
        
        .logo_loading {
            position: absolute;
            width: pxTorem(700px);
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        .loading-progress {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 100%;
            height: pxTorem(3px);
            border-radius: 5px;
            background: transparent;
            
            .loading-progress__bar {
                width: 0%;
                height: 100%;
                background: #fff;
            }
        }
    }

    .logo_anime {
        position: absolute;
        width: pxTorem(1320px);
        left: 50%;
        top: 51%;
        transform: translate(-50%, -50%);
    }

    .loading_page-enter-active, .loading_page-leave-active {
        transition: all 1s;
    }
    .loading_page-enter, .loading_page-leave-to {
        opacity: 0;
    }
}
</style>
